import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { brandConfig } from '../config/brands';
import { useMaterialsPanelStore } from '../stores/materialsPanelStore';
import MaterialsFloatingOpenButton from '../components/panels/MaterialsFloatingOpenButton';
import './HomeLanding.css';

export default function Take8HomePage() {
  const navigate = useNavigate();
  const { close } = useMaterialsPanelStore();
  const { attributeMode, scenarioMode, scenarioNoun } = brandConfig.labels;

  useEffect(() => {
    close();
  }, [close]);

  const openScenarioBook = () => {
    navigate('/studio/video?scenarioBook=1');
  };

  return (
    <div className="th-home">
      <div className="th-home-inner">

        {/* ─── 主導線: 静止画(属性選択) / 動画(シナリオ) ─── */}
        <div className="th-primary">
          <button
            className="th-card th-card--image"
            onClick={() => {
              // /studio/image の裸アクセスはプロンプトモードへ自動リダイレクトされるため、
              // 属性モードの意図を localStorage に表明しておく
              localStorage.setItem('studio_still_image_mode', 'attributes');
              navigate('/studio/image');
            }}
          >
            <div className="th-card-media">
              {/* 写真未配置でもブランド色グラデが見えるよう img はその上に重ねる */}
              <img src="/home/still-cover.png" alt="" className="th-card-photo" loading="lazy" />
              <div className="th-card-scrim" />
            </div>
            <div className="th-card-body">
              <div className="th-card-headrow">
                <img src="/picture_stack_landscape.svg" alt="" className="th-card-icon" />
                <span className="th-card-title">静止画生成</span>
                <span className="th-card-mode">{attributeMode}</span>
              </div>
              <span className="th-card-desc">媒体・背景・人物を選ぶだけでAIがバナー生成</span>
              <span className="th-card-cta">
                はじめる
                <span className="th-cta-circle" aria-hidden="true">
                  <span className="th-arrow" />
                </span>
              </span>
            </div>
          </button>

          <button
            className="th-card th-card--video"
            onClick={() => {
              // 静止画側と同様、/studio/video の裸アクセスはプロンプトモードへ
              localStorage.setItem('studio_scenario_mode', 'attributes');
              navigate('/studio/video');
            }}
          >
            <div className="th-card-media">
              <img src="/home/video-cover.png" alt="" className="th-card-photo" loading="lazy" />
              <div className="th-card-scrim" />
            </div>
            <div className="th-card-body">
              <div className="th-card-headrow">
                <img src="/video_player_movie.svg" alt="" className="th-card-icon" />
                <span className="th-card-title">動画生成</span>
                <span className="th-card-mode">{scenarioMode}</span>
              </div>
              <span className="th-card-desc">AIが{scenarioNoun}生成、動画生成から編集まで</span>
              <span className="th-card-ctarow">
                <span className="th-card-cta">
                  はじめる
                  <span className="th-cta-circle" aria-hidden="true">
                    <span className="th-arrow" />
                  </span>
                </span>
                {/* カード全体が button のため、実 button をネストせず role="button" の span にする */}
                <span
                  className="th-card-open"
                  role="button"
                  tabIndex={0}
                  onClick={(e) => {
                    e.stopPropagation();
                    openScenarioBook();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      e.stopPropagation();
                      openScenarioBook();
                    }
                  }}
                >
                  <img src="/book_book_pages.svg" alt="" className="th-card-open-icon" />
                  {scenarioNoun}を開く
                </span>
              </span>
            </div>
          </button>
        </div>

        {/* ─── サブ導線: 静止画 / 動画 で左右に分け、各列を縦並びに ─── */}
        <div className="th-secondary">
          {/* 静止画 */}
          <div className="th-submenu">
            <span className="th-submenu-label">その他静止画メニュー</span>
            <button className="th-sublink" onClick={() => navigate('/studio/image/prompt')}>
              <img src="/keyboard.svg" alt="" className="th-sublink-icon" />
              <span className="th-sublink-text">
                <span className="th-sublink-label">プロンプト入力モード</span>
                <span className="th-sublink-desc">自由な指示でバナーや画像を生成</span>
              </span>
              <span className="th-sublink-arrow" aria-hidden="true" />
            </button>
          </div>

          {/* 動画 */}
          <div className="th-submenu">
            <span className="th-submenu-label">その他動画メニュー</span>
            <button className="th-sublink" onClick={() => navigate('/studio/video/prompt')}>
              <img src="/keyboard.svg" alt="" className="th-sublink-icon" />
              <span className="th-sublink-text">
                <span className="th-sublink-label">プロンプト入力モード</span>
                <span className="th-sublink-desc">自由な指示で単発の動画を生成</span>
              </span>
              <span className="th-sublink-arrow" aria-hidden="true" />
            </button>
          </div>
        </div>

      </div>
      <MaterialsFloatingOpenButton />
    </div>
  );
}
